---
alert:
  anchorDrift:
    alarm: Le navire s'est déplacé de **{distance}** depuis la position de mouillage.
    warning: Le navire s'est déplacé de **{distance}** depuis la position de mouillage.
  depth:
    alarm: La profondeur actuelle de l'eau n'est que de **{depth}**.
    warning: La profondeur actuelle de l'eau n'est que de **{depth}**.
  lights:
    warning: Les feux recommandés sont **{recommended}**, mais **{recorded}** est actuellement enregistré.
  lostPosition:
    disconnected: La connexion à la source de position a été perdue.
    invalidFix: La source de position signale que sa position GPS n'est pas valide.
    jump: La source de position signale des positions invraisemblables. Elles sont ignorées.
    stale: Aucune position n'a été reçue depuis un certain temps.
  manOverboard:
    emitterActivated: Un émetteur homme à la mer a été activé. Réaction immédiate de tout l'équipage requise.
    manualButtonActivated: Le bouton manuel d'un émetteur homme à la mer a été activé. Réaction immédiate de tout l'équipage requise.
    manual: Un membre de l'équipage a déclenché manuellement une alerte homme à la mer. Réaction immédiate de tout l'équipage requise.
    unknown: Un signal homme à la mer a été reçu. Réaction immédiate de tout l'équipage requise.

anchorMonitor:
  explanation:
    fixedRadius: |-
      Vous alerte lorsque le navire s'éloigne au-delà d'une distance fixe de la position d'ancrage, indiquée directement comme un rayon en mètres.

      Utilisez cette méthode lorsque vous savez déjà de combien d'espace de giration vous disposez — par exemple dans un mouillage encombré où vous avez estimé vous-même la distance de sécurité par rapport aux bateaux voisins ou au rivage.
    rodeScope: |-
      Calcule le rayon de giration attendu à partir de la longueur de votre chaîne ou ligne d'ancre, de la profondeur d'eau et de la longueur de votre navire, plutôt qu'une distance fixe que vous saisissez vous-même.

      Utilisez cette méthode lorsque vous voulez que LOGBOOK calcule pour vous un rayon pertinent en fonction de la longueur de chaîne filée — il s'adapte automatiquement lorsque la marée modifie la profondeur.
    sector: |-
      Surveille un secteur de relèvement directionnel plutôt qu'un cercle complet, de sorte qu'une giration dans l'arc attendu reste silencieuse tandis qu'une dérive en dehors de celui-ci déclenche une alerte.

      Utilisez cette méthode dans un chenal étroit ou un mouillage fluvial, où la giration selon le courant est normale, mais où une dérive latérale vers une rive ou un autre navire ne l'est pas.

changeLog:
  '2026-09-30': |-
    La version 1.1 apporte de nombreuses nouvelles fonctionnalités utiles à LOGBOOK

    Nouvelles fonctionnalités
    * Statut manuel du navire – pour éviter les entrées « pause » indésirables (activé automatiquement pour les statuts « Pont » et « En attente »)
    * Veille au mouillage avec avertissement et alarme
    * Surveillance de la profondeur avec avertissement et alarme
    * Notifications concernant les signaux visuels requis par le Règlement international pour la sécurité de la navigation maritime (COLREG)
    * Entrées manuelles relatives au moteur : notification en cas d’entrée manquante pour « Moteur en marche » (peut être définie rétroactivement)
    * Avertissement en cas de problèmes avec les données NMEA
    * Alarme « homme à la mer »
    * Historique des modifications – pour une fiabilité encore plus grande des preuves
    * Régime de ralenti des moteurs réglable – le fonctionnement au ralenti est signalé et n’est pas comptabilisé comme un déplacement sous la puissance du moteur

    Améliorations
    * Encore plus de fonctions pour les saisies manuelles dans le journal, désormais sélectionnables directement dans le menu « Journal »
    * Saisies manuelles des données moteur : le régime peut être ajouté rétroactivement en mode « Focus »
    * Les membres d’équipage, etc., ne peuvent être modifiés que pour la journée en cours et la journée suivante
    * La connexion à des appareils Companion via Bonjour est possible pour des configurations supplémentaires
    * Améliorations apportées à la boîte de dialogue de connexion avec des messages d’erreur plus clairs
    * Optimisations internes approfondies qui rendent l’application encore plus rapide et plus fiable

    Corrections de bugs
    * Nombreuses optimisations majeures et mineures ainsi que corrections de bugs

  '2026-08-14': |-
    Voici les nouvelles fonctionnalités de la mise à jour du 2026-08-14 :

    Nouvelles fonctionnalités
    * Pour les jours terminés et les jours sans entrées de journal, des entrées peuvent désormais être ajoutées rétrospectivement aux cartes Prévisions météo, Journal et Technique.
    * Prise en charge du GPS interne sur Android
    * Avertissement en cas de défaillance du GPS
    * Sélection rapide des voiles dans le menu du bouton Log
    * Sur les appareils Android, le Primary LOGBOOK continue désormais de fonctionner lorsque l'application est en arrière-plan
    * Affichage des heures de lever et de coucher du soleil sur la feuille de données du jour
    * Nouvelles options Pont et En attente pour les escales und de l'état du navire
    * Réglage de vitesse séparé pour déclencher l'entrée de départ au mouillage et à la bouée, pour éviter les entrées inutiles lors du mouvement de giration
    * Fonctions pour le téléchargement de données vers le support

    Améliorations
    * Nouveau design des boutons NMEA et Sync – état actuel plus clairement visible
    * Le menu du bouton Log s'ouvre désormais vers le haut pour éviter le défilement inutile
    * Les erreurs GPS ou les écarts de position excessifs (par exemple, causés par le brouillage GPS) sont ignorés
    * Sur les petits écrans, le bouton Stop n'apparaît désormais qu'avec une icône et peut être agrandi avec le bouton Développer
    * Lors du changement de la prise de ris d'une voile, la prise de ris précédente est automatiquement supprimée
    * Améliorations de la connexion de Companion à Primary, prise en charge de Bonjour
    * Texte amélioré pour les changements d'équipage, de skipper, etc.
    * Les entrées de journal générées par le système (par exemple, lors de pertes de données) n'apparaissent désormais qu'une seule fois

    Corrections de bugs
    * Le fuseau horaire est désormais correctement détecté sur Windows même lorsque le système n'est pas configuré en anglais comme langue
    * Les erreurs possibles dans les statistiques qui pouvaient survenir avec les entrées moteur manuelles sont automatiquement corrigées avec la mise à jour
    * Les entrées de journal en double générées par le système sont automatiquement supprimées avec la mise à jour
    * Android : les images peuvent désormais être téléchargées
    * Nombreuses optimisations et corrections de bugs, majeures et mineures.

  '2026-07-15': |-
    Voici les nouvelles fonctionnalités de la mise à jour du 2026-07-15 :
    
    Nouvelles fonctionnalités
    * Pour les entrées manuelles concernant le moteur (NMEA ne contient pas de données sur le régime moteur), il est désormais possible d'activer une option permettant de transférer automatiquement le régime saisi manuellement vers l'entrée suivante du journal de bord. Cela s'avère utile lors de trajets à régime constant. Cette option peut être activée dans les **Paramètres du bateau**, sous l'onglet **Paramètres** de la carte.

    Améliorations
    * Améliorations et corrections de bugs au niveau des statistiques, notamment dans le calcul de la durée totale et de la distance totale.
  
    Corrections de bugs
    * Nombreuses optimisations et corrections de bugs, majeures et mineures.

  '2026-07-05': |-
    Voici les nouvelles fonctionnalités de la mise à jour du 2026-07-05 :
    
    Nouvelles fonctionnalités
    * Le français est désormais disponible comme langue supplémentaire pour l'interface utilisateur.
    * Nouveau bouton de Log multifonctionnel et contextuel à côté de la ligne de log actuelle pour ajouter rapidement différents types d'entrées.
    * Les images dans les notes (journal, etc.) peuvent maintenant être supprimées.
    * Un décalage pour la valeur de distance du loch peut être défini dans les paramètres du navire (par exemple, si le loch n'affiche pas les miles totales correctes du navire).

    Améliorations
    * Diverses explications et conseils supplémentaires dans l'interface utilisateur
    * Les droits d'accès et le rôle d'équipage du propriétaire du compte sont désormais fixés pour éviter les problèmes de perte de droits d'accès.
    * Lorsque plusieurs ajouts sont effectués sur une entrée du journal, toutes les modifications sont désormais listées dans le commentaire.
    * Optimisations importantes du LOGBOOK Cloud et de la communication entre LOGBOOK Cloud et l'application LOGBOOK

    Corrections de bugs
    * Lorsqu'aucune donnée moteur n'est disponible dans NMEA, les boutons moteur sont désormais affichés immédiatement.
    * Correction d'un problème où 500 tr/min étaient saisis pour les données moteur manuelles après une interruption de données.
    * Le cap et le vent sont désormais correctement évalués même lorsque seules des données relatives sont présentes dans NMEA.
    * Correction d'un problème où des temps négatifs étaient affichés dans les statistiques.

  '2026-06-11': |-
    La mise à jour du 2026-06-11 apporte de nombreuses améliorations et corrections de bugs :

    Nouvelles fonctionnalités
    * Prise en charge de l'iPhone comme appareil companion.
    * Évaluation d'ensembles de données NMEA supplémentaires pour le cap, le vent, la température de l'air et la pression atmosphérique.

    Améliorations
    * Lorsque plusieurs ajouts sont effectués sur une entrée (par exemple, moteur arrêté et voiles établies), ils sont désormais entièrement listés dans le commentaire.
    * La déconnexion du LOGBOOK Primary n'est désormais possible qu'en même temps que la fermeture du LOGBOOK Primary.
    * Aide utilisateur optimisée grâce à des conseils, recommandations et avertissements améliorés.

    Corrections de bugs
    * Le test NMEA détecte désormais correctement lorsqu'il y a des valeurs du loch.
    * Correction d'un problème où le mauvais statut du jour était affiché sur la carte du jour.
    * Correction d'un problème où des changements d'équipage incorrects étaient enregistrés après que l'appareil soit passé en mode veille.
    * Correction d'un problème où un régime moteur incorrect était enregistré après une interruption de la connexion NMEA.
    * Optimisations supplémentaires et corrections de bugs dans les statistiques.

  '2026-05-30': |-
    Voici les nouvelles fonctionnalités de la mise à jour du 2026-05-30 :

    Nouvelles fonctionnalités
    * LOGBOOK peut désormais être utilisé à bord avec plusieurs appareils simultanément. La connexion se fait sur tous les appareils avec le même compte. Voir la documentation sur <a href="https://logbook.yachts/site/en/documentation/#h1_devices" target="_blank">**Multiple Devices**</a>.

    Corrections de bugs
    * Correction d'un problème où les images dépassaient occasionnellement de la zone d'impression lors de l'impression.
    * Correction d'un problème où la mauvaise date était affichée dans les fuseaux horaires occidentaux.
    * Le jour actuel affiche désormais toujours la bonne date et n'affiche plus le 1er janvier, même s'il n'y a pas d'entrées.
    * Les changements dans la feuille de données du jour suivant ne sont pas enregistrés.
    * Correction d'un problème où les changements dans l'équipage étaient enregistrés même si l'équipage n'avait pas été modifié.
    * Correction d'un problème où les entrées moteur manuelles après une interruption de connexion NMEA enregistraient un régime moteur.
    * Lors de l'arrêt, la durée correcte apparaît désormais directement sur le bouton d'arrêt.
    * Correction d'un problème où la distance et la durée étaient comptées deux fois dans les statistiques du jour.
    * iPad : Correction d'un écran blanc lors du passage du Cloud à l'App au sein de l'application.

  '2026-05-20': |-
    Voici les nouvelles fonctionnalités de la mise à jour du 2026-05-20 :

    Nouvelles fonctionnalités
    * Ajout de la connexion NMEA via UDP.
    * Les données de trace sont calculées en continu et synchronisées régulièrement, pas seulement à la fin de la journée.
    * Pour les jours où il n'y a pas de trace, la trace manquante est automatiquement générée lors du recalcul des statistiques (bouton sur les statistiques de la carte).
    * Pour les entrées moteur manuelles, le dialogue d'arrêt offre une option pour créer automatiquement des entrées pour **Moteur arrêté** également.

    Améliorations
    * Changement dans la détection des pauses. Cela devrait éviter les fausses pauses à basse vitesse ou en raison d'inexactitudes GPS, ainsi que les fins de pause incorrectes lors de mouvements de navire à court terme ou d'erreurs GPS.
    * Le **calcul du temps total** commence lorsque le navire part et se termine avec la dernière entrée lorsque le navire ne bouge plus. Les entrées non liées au trajet au début et à la fin ne sont plus prises en compte.

    Corrections de bugs
    * Correction d'un problème où après le redémarrage de la navigation le même jour, la distance recommençait à 0.

  '2026-05-12': |-
    Voici les nouvelles fonctionnalités de la mise à jour du 2026-05-12 :

    Nouvelles fonctionnalités
    * iPad : L'application LOGBOOK continue de fonctionner en arrière-plan et continue de créer des entrées log lorsque l'application n'est pas au premier plan.
    * iPad : Les photos peuvent désormais être prises directement depuis l'application et insérées dans les entrées du journal de bord.
    * iPad : Prise en charge des **appareils GPS externes** connectés via **Bluetooth** ou câble
    * Nouvelle fonction **Réinitialiser** au cas où la connexion du cloud au LOGBOOK Primary serait accidentellement déconnectée (indiquée par le marqueur rouge sur le bouton de synchronisation)

    Améliorations
    * iPad : Problèmes de mise en page après le retour de l'arrière-plan corrigés
    * Serveur : Améliorations dans le calcul des statistiques

  '2026-05-05': |-
    La mise à jour 2026-05-05 corrige quelques problèmes :

    * Correction d'un problème avec le GPS intégré de l'iPad, qui pouvait conduire à des entrées de pause incorrectes à très basse vitesse.
    * Correction d'un problème où une connexion NMEA désactivée était automatiquement activée lorsque l'application était mise au premier plan sur l'iPad.
    * Correction d'un problème où les entrées log et la ligne de log n'étaient pas affichées correctement lors du changement de taille de fenêtre (par exemple, en tournant la tablette).
    * Correction du format de champ incorrect dans les données du navire sur l'onglet **Équipement**.
    * Diverses optimisations mineures de mise en page
    * Diverses corrections mineures de bugs

    Si vous utilisez le GPS interne pour la réception de données, vous pouvez trouver des informations importantes dans notre conseil <a href="https://logbook.yachts/site/en/support/#ipadgps" target="_blank">**»Utiliser LOGBOOK avec le GPS interne de l'iPad«**</a>.

  '2026-04-27': |-
    La mise à jour 2026-04-27 apporte toute une série d'améliorations et de corrections de bugs.
    Cela inclut des optimisations supplémentaires de la mise en page pour différentes tailles d'écran ainsi que la gestion des erreurs lors de l'importation depuis Logbook Suite.

  '2026-04-14': |-
    Voilà la première mise à jour mineure. Voici ce que nous avons amélioré :

    * Mise en page optimisée pour les écrans moyens tels que les tablettes en mode portrait (768px à 1023px)
    * Le bouton d'impression fonctionne maintenant sur iPad
    * Améliorations lors de l'importation depuis Logbook Suite
    * Diverses corrections de bugs mineures

  '2026-04-04': |-
    Bienvenue sur LOGBOOK – le logiciel de journal de bord innovant pour les navigateurs et les passionnés de bateaux à moteur.

    Il s'agit de la version 1.0. À l'avenir, vous trouverez ici des informations sur les nouvelles fonctionnalités et améliorations après chaque mise à jour.

connection:
  interrupted: |-
    La connexion à l'application a été interrompue.

    Si la connexion ne se rétablit pas automatiquement, veuillez essayer de redémarrer l'application.
  recovered: |-
    La connexion à l'application a été rétablie.

    Veuillez recharger pour continuer à utiliser l'application.

currentView:
  firstTrip: |-
    **Un nouveau trajet est en cours de démarrage**

    Veuillez vérifier le **fuseau horaire** défini pour ce trajet.

    Le fuseau horaire est automatiquement défini sur le fuseau horaire système de l'appareil Primary. Pour modifier le fuseau horaire, vous devez changer le fuseau horaire système de l'appareil primary **avant** de commencer le trajet.

    Si le système de l'appareil primary n'a pas correctement transmis le fuseau horaire à LOGBOOK, vous pouvez modifier manuellement le fuseau horaire dans les **Paramètres du navire** sur l'onglet **Paramètres**. Cela doit également être fait **avant** de commencer le trajet.

    **Veuillez noter :** Une fois le trajet commencé ici, le fuseau horaire est fixe.

  demoWillStart: |-
    **Remarque :** Avec le début du premier trajet, vous commencez également votre phase d'essai de 5 jours.

  confirmationDialog:
    cruise:
      allowed: |-
        Commencer un nouveau voyage met fin au voyage actuel.

        Êtes-vous sûr de vouloir arrêter et terminer le voyage actuel ?

        **Veuillez noter** : L'enregistrement NMEA sera arrêté.
      deniedInMotion: |-
        Commencer un nouveau voyage n'est pas possible car le navire est en mouvement.
      deniedBlankExists: |-
        Commencer un nouveau voyage n'est pas possible car il existe déjà un voyage vide qui n'a pas encore été commencé.
    trip:
      allowed: |-
        Commencer un nouveau trajet met fin au trajet actuel.

        Êtes-vous sûr de vouloir arrêter et terminer le trajet actuel ?

        **Veuillez noter** : L'enregistrement NMEA sera arrêté.
      deniedInMotion: |-
        Commencer un nouveau trajet n'est pas possible car le navire est en mouvement.
      deniedBlankExists: |-
        Commencer un nouveau trajet n'est pas possible car il existe déjà un trajet vide qui n'a pas encore été commencé.

importShip:
  text: |-
    Comment importer vos journaux de bord depuis **Logbook Suite** vers **LOGBOOK** :

    **Étape 1 :** Dans Logbook Suite, utilisez la fonction **Exporter pour LOGBOOK** (disponible dans Logbook Suite Manager version 2.6 et ultérieure) via le bouton **Plus …** pour exporter tous les journaux de bord que vous avez créés pour votre navire.

    **Étape 2 :** Dans LOGBOOK, créez un nouveau navire avec le même nom. Fermez la boîte de dialogue affichée après la création pour afficher vos paramètres de compte dans le LOGBOOK Cloud. (Ignorez cette étape si vous avez déjà créé le navire. Assurez-vous que le navire est fermé à la fois dans le Cloud et dans l'application avant de passer à l'étape 3.)

    **Étape 3 :** Votre nouveau navire apparaît maintenant dans la liste. Sélectionnez **Options** pour le navire dans lequel vous souhaitez importer, puis choisissez **Importer depuis LogbookSuite**. Suivez les instructions. (La fonction d'importation n'est disponible que lorsque le LOGBOOK du navire n'est pas ouvert.)

    **Étape 4 :** Dans l'application LOGBOOK, commencez un nouveau voyage avant de débuter ou de poursuivre l'enregistrement de données avec LOGBOOK.

importTrips:
  text: |-
    Importez les journaux de bord créés avec **Logbook Suite** pour votre navire **{name}** dans **LOGBOOK**. Sélectionnez le fichier créé par l'outil d'exportation de Logbook Suite avec le nom suivant : ***[Nom du navire]_LOGBOOK_export.logbook***

    Si votre journal de bord importé contient des données de navire pas encore enregistrées dans LOGBOOK, les données de Logbook Suite seront importées. Les données de navire déjà saisies dans LOGBOOK ne seront pas écrasées.

    **Remarque importante :** Le processus d'importation peut prendre du temps, surtout si vous avez un grand journal de bord. Veuillez être patient et ne pas interrompre le processus.

    **Attention :** Après l'importation, vous devez commencer un **nouveau voyage** avant de commencer ou de poursuivre l'enregistrement de données dans LOGBOOK.

login:
  welcomeCloud: |-
    Connectez-vous ou créez votre compte et commencez à tenir le journal de bord de votre navire avec LOGBOOK.

    Vous pouvez essayer LOGBOOK gratuitement et créer des entrées pendant 5 jours.

  welcomeApp: |-
    Connexion à l'application LOGBOOK.

    Si vous n'avez pas encore de compte, vous pouvez en créer un [ici](logbook:signup).

  welcomeAppiPad: |-
    Connexion à l'application **LOGBOOK for Yachts** pour iOS.

    Si vous n'avez pas encore de compte, vous pouvez en créer un [ici](logbook:signup).

  signupSuccess: |-
    Votre compte a été créé.

    Nous vous avons envoyé un e-mail pour activation. Veuillez cliquer sur le lien dans l'e-mail pour continuer.

  invitation: |-
    {inviter} vous a invité et souhaite vous donner accès à son LOGBOOK pour **{ship}**.

    Si vous avez déjà un compte pour LOGBOOK, connectez-vous simplement à votre compte.

    Si vous n'êtes pas encore inscrit sur LOGBOOK, veuillez vous inscrire ici pour créer votre compte gratuit. Vous serez ensuite connecté directement.

    Après la connexion, votre compte LOGBOOK sera connecté au compte LOGBOOK de {inviter}. Ensuite, connectez-vous à l'application LOGBOOK. Dans la liste des navires dans vos paramètres de compte, **{ship}** apparaîtra sous **Sélectionner parmi les navires partagés**, et vous pourrez vous connecter directement en tant que companion au LOGBOOK pour {ship}.

  invitationLoggedIn: |-
    {inviter} vous a invité et souhaite vous donner accès à son LOGBOOK pour **{ship}**.

    En cliquant sur **Accepter l'invitation**, vous confirmez l'invitation. Ensuite, connectez-vous à l'application LOGBOOK. Dans la liste des navires dans vos paramètres de compte, **{ship}** apparaîtra sous **Sélectionner parmi les navires partagés**, et vous pourrez vous connecter directement en tant que companion au LOGBOOK pour {ship}.

    En cliquant sur **Utiliser un autre compte**, vous pouvez également sélectionner ou créer un autre compte pour accéder au LOGBOOK pour {ship}.

  resetAppWarning: |-
    Si vous rencontrez des problèmes pour démarrer l'application ou ouvrir un navire, vous pouvez réinitialiser l'application LOGBOOK avec cette fonction.

    Toutes les données stockées sur l'appareil seront supprimées. Toutes les données qui ont été téléchargées depuis l'application LOGBOOK vers le LOGBOOK Cloud, et qui y sont stockées, seront conservées.

    Après la réinitialisation, vous devez rouvrir l'application LOGBOOK et vous connecter avec votre compte. Lors de l'ouverture de votre navire, l'application LOGBOOK chargera alors à nouveau toutes les données depuis le LOGBOOK Cloud.

    **Important !** N'effectuez la réinitialisation de l'application LOGBOOK que lorsque vous avez une connexion Internet.

    Êtes-vous sûr de vouloir réinitialiser l'application ?

  resetAppComplete: |-
    La réinitialisation de l'application LOGBOOK est terminée.

    Si l'application LOGBOOK n'a pas été automatiquement fermée, vous devez la fermer manuellement (kill) via le système d'exploitation et la redémarrer.

logout:
  logoutWithInternet: |-
    **Avertissement – LOGBOOK Primary pour {name} ouvert**

    Le **LOGBOOK Primary {name}** est toujours ouvert dans l'application. La déconnexion fermera le LOGBOOK Primary. Pour rouvrir le LOGBOOK Primary, une connexion Internet est requise.

  logoutWithoutInternet: |-
    **Déconnexion impossible – pas de connexion Internet**

    Une connexion Internet est requise pour se déconnecter. Veuillez vérifier votre connexion et réessayer.

nmeaSettings:
  connectionTypeNative: |-
    Pour utiliser le **GPS interne**, sélectionnez l'option **GPS intégré** sous **Type de connexion NMEA**. Sur la carte **Test et données**, la réception GPS via le GPS intégré est affichée séparément.

    Un **appareil GPS externe** connecté via **Bluetooth** ou **câble** à l'iPad se comporte de la même manière que le GPS interne. Par conséquent, pour l'appareil GPS externe, sélectionnez également le type de connexion **GPS intégré**.

    Les **capteurs internes** supplémentaires disponibles, tels qu'un **baromètre interne**, peuvent être activés indépendamment du GPS intégré sur la carte **Capteurs internes**.

  connectionTypeNativeWarning: |-
    **Remarque importante**

    Pour éviter les entrées incorrectes lors de l'utilisation du GPS interne, avant de retirer l'iPad du navire, déconnectez la connexion NMEA ou fermez le LOGBOOK Primary de votre navire via la commande de menu.

    Veuillez noter qu'une connexion Internet est requise à la fois pour fermer le navire et pour le rouvrir.

noteText:
  uninitialized: |-
    **Initialisation de la synchronisation**

    Veuillez patienter. Cela peut prendre quelques minutes.
  failed: La synchronisation a échoué. Nouvelle tentative prochainement.
  initialSyncFailed: La synchronisation initiale a échoué. Nouvelle tentative prochainement.
  initialSyncInProgress: |-
    **Synchronisation initiale démarrée**

    Veuillez patienter. Cela peut prendre quelques minutes.
  dataWaiting: En attente de synchronisation.
  inProgress: |-
    **Synchronisation en cours**

    Veuillez patienter. Cela peut prendre quelques minutes.
  current: Entièrement synchronisé.
  disconnected: |-
    **Connexion au LOGBOOK Cloud perdue**

    Cet appareil n'est plus enregistré comme LOGBOOK principal, la synchronisation est donc arrêtée.

    Utilisez **Reconnecter** dans le menu **Sync** pour rétablir la connexion. Il vous sera demandé si les données de cet appareil ou celles du LOGBOOK Cloud doivent être conservées.
  transition: |-
    **Préparation de vos données**

    Les entrées existantes sont mises à jour pour cette version. Veuillez patienter, cela peut prendre quelques minutes.
  resync: |-
    Les données de votre appareil sont en cours de téléchargement vers le LOGBOOK Cloud.
  newShip: |-
    **Remarque importante**

    Le **type de navire** et le **nombre de moteurs** ne peuvent pas être modifiés après la création du navire.

  shipOpen: |-
    Le **LOGBOOK Primary** pour **{name}** est déjà ouvert sur un autre appareil.

    **Cas 1 - Vous êtes à bord du navire**

    Assurez-vous que votre appareil est connecté au **réseau interne du navire**.
    Entrez ensuite l'adresse du LOGBOOK Primary ici pour établir une connexion. Utilisez le format **IP:Port**, par exemple 192.168.0.100:8000. Vous pouvez trouver l'adresse dans le LOGBOOK Primary dans les **Paramètres du navire** sous **Companions**.

  shipOpen2: |-
    ** **

    **Cas 2 - Aucun réseau interne de navire disponible ou vous n'êtes pas à bord du navire**

    Vous pouvez toujours consulter le dernier état synchronisé du journal de bord dans le **LOGBOOK Cloud**.

    ** **

    **Cas 3 - Vous souhaitez ouvrir le journal de bord en tant que LOGBOOK Primary sur cet appareil**

    Si nécessaire, vous pouvez utiliser **Déconnecter le LOGBOOK Primary** pour déconnecter de force la connexion entre le LOGBOOK Primary et le LOGBOOK Cloud.

  shipNotClosed: |-
    Utilisez cette fonction uniquement si vous êtes sûr que le LOGBOOK Primary doit être déconnecté du LOGBOOK Cloud – par exemple, parce que l'appareil primary est défectueux ou pour d'autres raisons l'accès à l'appareil primary n'est plus possible.

    Toutes les données enregistrées après la déconnexion du LOGBOOK Primary ne seront pas synchronisées et peuvent être perdues.

    - Utilisez le bouton ci-dessous pour passer à la liste des navires dans le LOGBOOK Cloud.

    - Ouvrez le dialogue **Options** avec le bouton **Options** (le bouton affiche une couleur différente pour le navire concerné). Vous pouvez maintenant déconnecter le navire via ce dialogue.

    Après une courte attente, le LOGBOOK Primary du navire peut être rouvert. Si nécessaire, vous pouvez actualiser la vue avec le bouton d'actualisation. La réouverture peut prendre plusieurs minutes car l'application LOGBOOK doit récupérer toutes les données du LOGBOOK Cloud.

  shipOpenCompanion: |-
    Entrez l'adresse du LOGBOOK Primary ici pour établir une connexion.

    Utilisez le format **IP:Port**, par exemple **192.168.0.100:8000**.

    Vous pouvez trouver l'adresse dans le LOGBOOK Primary dans les paramètres du navire sur la carte **Companions**.

  shipsSmartphone: |-
    LOGBOOK ne peut être utilisé que comme Companion sur un smartphone et offre donc des fonctionnalités limitées.

    Seuls les navires dont le LOGBOOK Primary est déjà en cours d'exécution sur un autre appareil peuvent être sélectionnés. Pour la connexion Companion, votre smartphone doit être sur le même réseau que l'appareil primary.

  selectShip: |-
    Sélection du navire sur le cloud LOGBOOK.
  selectShipFailed: |-
    La sélection du navire a échoué sur le cloud LOGBOOK.

    Veuillez réessayer dans quelques minutes.
  limitActiveShipsReached: |-
    Vous avez atteint votre limite de navires actifs.

    Pour sélectionner un autre navire, vous devez d'abord fermer le navire actuellement ouvert sur le cloud LOGBOOK.
  startShip: |-
    <strong>Votre navire "{name}" a été créé – Passez maintenant à l'application LOGBOOK</strong>

    Votre nouveau navire a été créé avec succès et est maintenant affiché ici dans le **cloud LOGBOOK**.

    Si vous le souhaitez, vous pouvez directement saisir plus de données de navire ici dans le cloud LOGBOOK. Pour cela, sélectionnez l'élément de menu **Données du navire {name}** dans le menu <strong>{name}</strong>.

    Ensuite, le premier voyage et le premier trajet doivent être préparés. Pour cela, ouvrez votre nouveau navire dans l'**application LOGBOOK**. Si vous n'avez pas encore installé l'application LOGBOOK, vous pouvez trouver les liens de téléchargement ici : <a href="https://logbook.yachts/site/en/download" target="_blank">Télécharger l'application LOGBOOK</a>.

    Une fois le premier voyage et le premier trajet créés, ils seront également affichés ici dans le cloud LOGBOOK.
  firstLogin: |-
    **Bienvenue sur LOGBOOK** – le logiciel de journal de bord innovant

    **Votre compte a été créé avec succès.**

    <li>Créez maintenant votre <strong>premier navire</strong> …</li>
    <li>… configurez la <strong>connexion NMEA</strong> …</li>
    <li>… et vous êtes <strong>prêt pour votre premier trajet</strong> avec LOGBOOK.</li>

    Des instructions détaillées se trouvent dans le <a href="https://logbook.yachts/site/en/documentation/#h1_quickstart" target="_blank">QuickStart</a> et dans les <a href="https://logbook.yachts/site/en/demos" target="_blank">Démos interactives</a>.

  firstLoginCloud: |-
    Si vous n'avez pas encore installé l'application LOGBOOK, vous pouvez trouver les liens de téléchargement ici : <a href="https://logbook.yachts/site/en/download" target="_blank">Télécharger l'application LOGBOOK</a>.

sessionExpired:
  text: |-
    **Connexion requise – aucune liaison avec le LOGBOOK Cloud**

    Le LOGBOOK Cloud n'accepte plus la connexion de cet appareil. Rien n'est perdu : votre navire reste ouvert et tout ce que vous enregistrez est conservé sur cet appareil.

    Tant que vous ne vous reconnectez pas, aucune donnée n'est synchronisée avec le Cloud et aucun autre appareil ne voit vos saisies.

shipClose:
  text: |-
    Êtes-vous sûr de vouloir fermer le LOGBOOK Primary pour le navire nommé **{name}** ?

    **Cela arrêtera l'enregistrement des données et se déconnectera du NMEA.**

    Veuillez également noter : Vous aurez besoin d'une **connexion Internet** si vous souhaitez revenir à ce navire plus tard !

  internet: |-
    **Fermeture du navire impossible – pas de connexion Internet**

    Une connexion Internet est nécessaire pour fermer le navire. Veuillez vérifier votre connexion et réessayer.

  forceWarning: |-
    **Forcer la fermeture uniquement sur cet appareil ?**

    Cette action ferme **{name}** localement sans synchronisation. Le navire reste revendiqué dans le LOGBOOK Cloud et doit y être fermé manuellement avant de pouvoir être rouvert.

    Les données locales non synchronisées restent stockées sur cet appareil.

  keepOpen: |-
    **Conseil :**
    <p>Nous recommandons de garder le <strong>LOGBOOK Primary ouvert</strong> pendant tout le voyage. <br>
    Après la fin de la journée, vous pouvez simplement fermer l'application. <br>
    Gardez le <strong>LOGBOOK Primary ouvert</strong> et <strong>ne vous déconnectez pas</strong>. L'enregistrement des données sera alors interrompu, mais le statut du LOGBOOK Primary sera conservé. <br>
    Après le redémarrage de l'application, le LOGBOOK Primary est immédiatement disponible.</p>

  noSync: |-
    La synchronisation avec le LOGBOOK Cloud a échoué car ce LOGBOOK n'est plus enregistré en tant que LOGBOOK Primary dans le LOGBOOK Cloud.

    Si vous fermez le navire, toutes les modifications qui n'ont pas encore été enregistrées dans le LOGBOOK Cloud seront perdues.

    Vous pouvez essayer de restaurer la connexion au LOGBOOK Cloud en utilisant **Reconnecter** dans le menu **Sync**, synchroniser les données, puis fermer le navire.

shipInfo:
  disconnect: |-
    Êtes-vous sûr de vouloir déconnecter le LOGBOOK Primary pour le navire nommé **{name}** ?

    **Cela arrêtera toute synchronisation de ce journal de bord avec le LOGBOOK Cloud.**

    Veuillez également noter :

    Si le LOGBOOK Primary sur le navire n'a pas de connexion Internet, toutes les données enregistrées après la déconnexion ne seront pas synchronisées et peuvent être perdues.
  resync: |-
    Le LOGBOOK Primary pour votre navire **{name}** n'est plus connecté au LOGBOOK Cloud. Pour restaurer cette connexion, les données doivent être synchronisées à nouveau.

    Soit les données sur l'appareil, soit les données dans le LOGBOOK Cloud seront réinitialisées. Ensuite, cet appareil sera configuré comme **LOGBOOK Primary** pour **{name}**. Enfin, les données seront synchronisées entre le LOGBOOK Primary et le LOGBOOK Cloud.

    **Avertissement !**

    Cette fonction est destinée à un usage d'urgence uniquement. Ne l'exécutez que sur l'appareil configuré comme **LOGBOOK Primary** pour **{name}**. Si le LOGBOOK Primary est effectivement configuré sur un appareil différent, les données enregistrées avec cet appareil peuvent être perdues.

    * Vérifiez d'abord si les données ici dans l'application LOGBOOK ou dans le LOGBOOK Cloud sont plus récentes.

    * Décidez ensuite si vous souhaitez conserver les données ici dans l'application LOGBOOK ou les données dans le LOGBOOK Cloud comme données actuelles.

    * Sélectionnez le bouton approprié pour démarrer le processus.

  resyncUnavailable: |-
    La réinitialisation du LOGBOOK pour votre navire **{name}** n'a pas pu être complétée car un appareil est toujours connecté au navire dans le LOGBOOK Cloud.

    **Important :** Vérifiez d'abord si le LOGBOOK Primary est actuellement en cours d'exécution sur un autre appareil. Si c'est le cas, démarrez le processus depuis cet autre appareil et suivez les étapes là-bas.

    Pour procéder ici, déconnectez cet appareil dans le LOGBOOK Cloud :

    * Passez au LOGBOOK Cloud en utilisant la commande **Vers LOGBOOK Cloud** dans le menu **Compte**.
    * Dans le LOGBOOK Cloud, le bouton **Options** à côté de votre navire est surligné en bleu.
    * Dans les options, sélectionnez **Déconnecter le navire**.
    * Revenez à l'application LOGBOOK.
    * Ouvrez à nouveau le dialogue pour restaurer la synchronisation. Vous pouvez maintenant choisir quelles données vous souhaitez conserver.

  resync_reset_local_confirm: |-
    **Voulez-vous vraiment utiliser les données locales ?**

    Cette action réinitialisera les données du cloud.

    Cette action ne peut pas être annulée et entraînera la perte de toutes les données stockées dans le LOGBOOK Cloud et non présentes sur cet appareil.
  resync_reset_cloud_confirm: |-
    **Voulez-vous vraiment utiliser les données du cloud ?**

    Cette action réinitialisera les données locales.

    Cette action ne peut pas être annulée et entraînera la perte de toutes les données stockées uniquement sur cet appareil et non présentes dans le LOGBOOK Cloud.
shipSetting:
  utc: |-
    **Remarque importante**

    **Veuillez noter que le fuseau horaire pour l'heure du navire est fixe pour l'ensemble du trajet une fois qu'il a commencé.** Toute modification ici n'affectera pas un trajet déjà commencé.

  utc_info: |-
   LOGBOOK définit généralement l'heure du navire sur l'heure système de l'appareil primary.

    Dans certains cas, le système de l'appareil primary peut ne pas transmettre correctement le fuseau horaire à LOGBOOK. Dans ce cas, vous avez la possibilité de définir manuellement le fuseau horaire pour l'heure du navire.

  log_offset: |-
    Si votre transducteur de loch a été remplacé et que la valeur de loch précédente n'a pas pu être transférée, entrez l'ancienne valeur ici comme décalage. Elle sera automatiquement ajoutée aux nouvelles mesures, garantissant que la distance totale de votre navire est correctement continuée.
  keep_rpm: |-
    Si aucune donnée moteur n'est disponible via NMEA, vous pouvez activer cette option pour reporter automatiquement la valeur de RPM que vous avez saisie manuellement dans la prochaine entrée de journal. Cela est utile lorsque la vitesse du moteur ne change pas entre les entrées.
  lights: |-
    Lorsqu'elle est activée, LOGBOOK vous rappelle discrètement, dans un bouton sur la ligne de journal actuelle, dès que les signaux visuels enregistrés pour le navire ne correspondent pas à ce que le RIPAM recommande pour l'état de propulsion et l'heure actuels.
    
    Aucune alarme n'est jamais déclenchée — enregistrer les signaux visuels correspondants ferme le rappel. 
    
    Configurez les feux que votre navire porte à la voile, si la limite jour/nuit suit le crépuscule civil ou le coucher/lever du soleil, et si le cône de moteur optionnel doit faire l'objet d'un rappel.
  edit_permissiveness: |-
    Contrôle la permissivité de la modification d'une entrée de journal ou de jour une fois enregistrée. Cela affecte chaque entrée existante et future dès que le réglage est modifié — pas seulement les entrées créées par la suite.

    **Par défaut (strict)** — le comportement actuel. Une valeur fournie en direct par NMEA (par ex. cap, profondeur, régime moteur, loch, pression, température, humidité, vent, cap et vitesse fond) reste verrouillée jusqu'à ce que vous la corrigiez manuellement, et n'est modifiable que peu de temps après son enregistrement.

    Le régime moteur saisi manuellement fait exception à la restriction de temps : il peut aussi être saisi ou corrigé dans les entrées antérieures. Les valeurs encore protégées comme données NMEA restent verrouillées.

    **Étendu** — supprime la restriction de temps, de sorte que les valeurs fournies par NMEA peuvent encore être corrigées plus tard, mais les valeurs qui n'ont pas encore été corrigées manuellement restent protégées.

    **Illimité** — supprime entièrement cette protection. Chaque valeur, y compris celles fournies en direct par NMEA, peut être modifiée à tout moment. **À utiliser avec précaution :** cela supprime l'indication qu'une valeur a été enregistrée automatiquement par un capteur plutôt que saisie ou modifiée manuellement, ce qui peut avoir de l'importance pour la valeur probante de votre journal de bord.

    Certains champs (par ex. la distance) sont toujours calculés automatiquement et ne peuvent jamais être modifiés directement, quel que soit le niveau.

planDescriptions:
  captain: |-
    Abonnement annuel pour professionnels, longueur de navire inférieure à 24 m
  master_captain: |-
    Abonnement annuel pour professionnels, longueur de navire à partir de 24 m
  skipper: |-
    Abonnement mensuel ou annuel pour capitaines privés
  skipper_inApp: |-
    Abonnement mensuel pour capitaines privés – achat intégré
  trial: |-
    Essai gratuit de 5 jours

subscription:
  checkoutComplete: |-
    Achat réussi.

  checkoutProcessing: |-
    Finalisation de votre achat...

  subscriptionMessage: |-
    Choisissez un forfait.

    Quel que soit l'appareil à partir duquel vous achetez cet abonnement, vous pouvez utiliser LOGBOOK avec tous les appareils pris en charge simultanément ou alternativement (macOS, Windows, Android et iOS). L'abonnement n'est pas lié à une plateforme spécifique.

  subscriptionMessageiPad: |-
    Abonnez-vous pour continuer à utiliser LOGBOOK avec toutes ses fonctionnalités après la fin de votre période d'essai.

    Une fois les 5 jours gratuits écoulés, vous pouvez seulement consulter et imprimer vos données enregistrées. Aucune nouvelle saisie ni modification n'est possible.

    L'abonnement mensuel **LOGBOOK Skipper** est particulièrement adapté aux capitaines privés qui souhaitent tenir leur journal de bord de préférence ou exclusivement sur l'iPad. L'abonnement se renouvelle automatiquement et peut être annulé à la fin de chaque période.

    Cet abonnement peut également être utilisé sur d'autres plateformes, simultanément ou alternativement.

  demo1Day: |-
    **La phase d'essai se termine dans un jour**

    Il vous reste encore un jour pour tester LOGBOOK gratuitement et créer des entrées.

    Après cela, vous pouvez continuer sans interruption avec un abonnement et poursuivre votre journal de bord.

  demo2Days: |-
    **La phase d'essai se termine dans 2 jours**

    Vous pouvez encore créer des entrées dans LOGBOOK gratuitement pendant 2 jours supplémentaires.

    Après cela, vous pouvez continuer sans interruption avec un abonnement et poursuivre votre journal de bord.

  demoEnded: |-
    **Phase d'essai terminée**

    Votre phase de d'essai est terminée. Avec un abonnement, vous pouvez maintenant poursuivre votre journal de bord. Nous conserverons vos données de test stockées dans le LOGBOOK Cloud pendant encore 6 mois.

  demoToday: |-
    **La phase d'essai se termine aujourd'hui**

    Vous pouvez encore créer des entrées dans LOGBOOK gratuitement aujourd'hui.

    Après cela, la phase d'essai se termine. Avec un abonnement, vous pouvez poursuivre votre journal de bord à tout moment.

  demoStarted: |-
    **Phase d'essai démarrée**

    Votre phase d'essai a commencé avec votre première entrée dans LOGBOOK.

    Vous pouvez maintenant créer des entrées de journal de bord pendant un total de **5 jours**.

  subscription7Days: |-
    **L'abonnement se termine dans quelques jours**

    Votre abonnement expirera bientôt. Ne vous inquiétez pas – le renouvellement sera automatique, vous pouvez donc continuer à utiliser votre journal de bord sans interruption.

    Si vous souhaitez ajuster votre abonnement, vous pouvez le faire à tout moment.

  subscriptionExpired: |-
    **Abonnement expiré**

    Votre abonnement a expiré. Mais ne vous inquiétez pas – toutes vos données resteront stockées en toute sécurité dans le LOGBOOK Cloud pendant encore 2 ans.

    Renouvelez votre abonnement maintenant pour continuer votre journal de bord.

  subscriptionToday: |-
    **L'abonnement se termine aujourd'hui**

    Votre abonnement expire aujourd'hui. Renouvelez-le maintenant pour continuer à utiliser votre journal de bord.

  removeAccount: |-
    Confirmez la suppression du compte.

    Cela supprimera définitivement le compte "{account}" et l'utilisateur "{user}".

    Vous perdrez l'accès à tous les navires, voyages, trajets et entrées de journal de bord associés à ce compte.

  removeAccountDone: |-
    Votre compte "{account}" et l'utilisateur "{user}" dans LOGBOOK ont été supprimés avec succès.

mailer:
  footer: ''
  templates:
    signupConfirmation:
      subject: ''
      footer: ''
      body: ''
    signupWelcome:
      subject: ''
      footer: ''
      body: ''
    invited:
      subject: ''
      footer: ''
      body: ''
    passwordReset:
      subject: ''
      footer: ''
      body: ''
    betaInvite:
      subject: ''
      footer: ''
      body: ''
    subscriptionWelcomeSkipper:
      subject: ''
      footer: ''
      body: ''
    subscriptionWelcomeCaptain:
      subject: ''
      footer: ''
      body: ''
    subscriptionWelcomeMasterCaptain:
      subject: ''
      footer: ''
      body: ''
    trialStarted:
      subject: ''
      footer: ''
      body: ''
    trialExpiring:
      subject: ''
      footer: ''
      body: ''
    trialExpired:
      subject: ''
      footer: ''
      body: ''
    contact:
      subject: ''
      footer: ''
      body: ''
    betaContact:
      subject: ''
      footer: ''
      body: ''
